<div class="tracker-main">
    <div class="container start-container">
        <div class="row mt50">
            <div class="col-sm-6">
                <div class="left-part">
                    <em class="icon-icn-car-config font100 text-primary"></em>
                </div>
            </div>
            <div class="col-sm-6 d-flex align-center">
                <div class="right-part">
                    <h2 class="h3">{{message}}</h2>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer-site-info></app-footer-site-info>
